import React from "react";
import { Stack, Text, Icon } from "@fluentui/react";

const WebhooksOutboundPage = () => {
  return (
    <Stack 
      tokens={{ childrenGap: 32 }} 
      styles={{ 
        root: { 
          padding: "48px 24px",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center"
        } 
      }}
    >
      {/* Icon */}
      <Icon
        iconName="CloudUpload"
        styles={{
          root: {
            fontSize: 120,
            color: "#0078d4",
            opacity: 0.8
          }
        }}
      />
      
      {/* Main Title */}
      <Text
        variant="xxLarge"
        styles={{
          root: {
            fontWeight: "600",
            color: "#323130",
            marginBottom: "16px"
          },
        }}
      >
        Outbound Webhooks
      </Text>
      
      {/* Coming Soon Badge */}
      <div
        style={{
          display: "inline-block",
          padding: "8px 24px",
          backgroundColor: "#fff4ce",
          border: "2px solid #ffb900",
          borderRadius: "20px",
          marginBottom: "24px"
        }}
      >
        <Text
          variant="mediumPlus"
          styles={{
            root: {
              fontWeight: "600",
              color: "#8a6914",
              textTransform: "uppercase",
              letterSpacing: "1px"
            }
          }}
        >
          Coming Soon
        </Text>
      </div>
      
      {/* Description */}
      <Stack tokens={{ childrenGap: 16 }} styles={{ root: { maxWidth: "600px" } }}>
        <Text 
          variant="large" 
          styles={{ 
            root: { 
              color: "#605e5c",
              lineHeight: "1.6"
            } 
          }}
        >
          The Outbound Webhooks module is currently under development and will provide 
          comprehensive capabilities to send events to external systems.
        </Text>
        
        <Text 
          variant="medium" 
          styles={{ 
            root: { 
              color: "#8a8886",
              fontStyle: "italic"
            } 
          }}
        >
          Stay tuned for powerful event broadcasting, delivery guarantees, and retry mechanisms.
        </Text>
      </Stack>
      
      {/* Features Preview */}
      <Stack 
        horizontal 
        tokens={{ childrenGap: 40 }} 
        styles={{ 
          root: { 
            marginTop: "32px",
            "@media (max-width: 768px)": {
              flexDirection: "column",
              gap: "16px"
            }
          } 
        }}
      >
        <Stack tokens={{ childrenGap: 8 }} styles={{ root: { alignItems: "center" } }}>
          <Icon iconName="CloudUpload" styles={{ root: { fontSize: 32, color: "#0078d4" } }} />
          <Text variant="medium" styles={{ root: { fontWeight: "600", color: "#323130" } }}>
            Event Broadcasting
          </Text>
        </Stack>
        
        <Stack tokens={{ childrenGap: 8 }} styles={{ root: { alignItems: "center" } }}>
          <Icon iconName="Refresh" styles={{ root: { fontSize: 32, color: "#0078d4" } }} />
          <Text variant="medium" styles={{ root: { fontWeight: "600", color: "#323130" } }}>
            Retry Logic
          </Text>
        </Stack>
        
        <Stack tokens={{ childrenGap: 8 }} styles={{ root: { alignItems: "center" } }}>
          <Icon iconName="CheckMark" styles={{ root: { fontSize: 32, color: "#0078d4" } }} />
          <Text variant="medium" styles={{ root: { fontWeight: "600", color: "#323130" } }}>
            Delivery Guarantees
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default WebhooksOutboundPage;
